import type { FC } from "react";
import React from "react";

import { Outlet } from "react-router-dom";

import Footer from "shared/Components/Footer";
import Header from "shared/Components/Header";

interface MainContentProps {
	openAuthModal: (flow: "bonus" | "login" | "signUp") => void;
	onOpenGameSearchModal: () => void;
	onToggleMenu: () => void;
}

const MainContent: FC<MainContentProps> = ({ openAuthModal, onOpenGameSearchModal, onToggleMenu }) => (
	<main className="flex flex-col flex-1 h-full pb-3 w-full">
		<div className="flex-1 pt-[7px]">
			<div className="mb-5">
				<Header
					onOpenAuthModal={openAuthModal}
					onOpenGameSearchModal={onOpenGameSearchModal}
					onToggleMenu={onToggleMenu}
				/>
			</div>
			<div className="page-container">
				<Outlet />
			</div>
		</div>
		<div className="mt-3">
			<div className="page-container">
				<Footer />
			</div>
		</div>
	</main>
);

export default MainContent;
